const LOADER_STYLES = `
:host {
    display: flex !important;
    flex-direction: column !important;
    height: 100% !important;
    min-height: 80px !important;
    position: relative !important;
    width: 100% !important;
    border: none !important;
    border-radius: 0 !important;
    animation: none !important;
    aspect-ratio: auto !important;
    clip-path: none !important;
    transform: none !important;
    top: auto !important;
    left: auto !important;
    bottom: auto !important;
    right: auto !important;
    inset: auto !important;
}

.loader-title {
    color: var(--primary);
}

.loader-ring {
    align-self: center;
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}

.loader-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 4px solid var(--primary);
    border-radius: 50%;
    animation: loader-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: var(--primary) transparent transparent transparent;
}

.loader-ring div:nth-child(1) { animation-delay: -0.45s; }
.loader-ring div:nth-child(2) { animation-delay: -0.30s; }
.loader-ring div:nth-child(3) { animation-delay: -0.15s; }

@keyframes loader-ring {
    0%   { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
`;

const encapsulate = (el) => {
    if (el.shadowRoot) return;

    const fragment = document.createDocumentFragment();
    while (el.firstChild) fragment.appendChild(el.firstChild);

    const shadow = el.attachShadow({ mode: 'open' });
    const style = document.createElement('style');
    style.textContent = LOADER_STYLES;
    shadow.appendChild(style);
    shadow.appendChild(fragment);
}

const encapsulateAll = (root) => {
    root.querySelectorAll('.loader').forEach(encapsulate);
}

export const initEncapsulatedLoader = () => {
    encapsulateAll(document);

    const observer = new MutationObserver((mutations) => {
        for (const m of mutations) {
            for (const node of m.addedNodes) {
                if (node.nodeType !== 1) continue;
                if (node.matches && node.matches('.loader')) {
                    encapsulate(node);
                } else if (node.querySelectorAll) {
                    encapsulateAll(node);
                }
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
}


